module.exports = __webpack_public_path__ + "static/media/animal-05.29de142f.png";